import logo from "./logo.svg";
import "./App.css";
import Header from "./Header";
import Home from "./Home";
import Sites from "./Sites";
import Team from "./Team";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  Switch,
} from "react-router-dom";
import SiteDetails from "./SiteDetails";
import About from "./About";
import Services from "./Services";
import Faq from "./Faq";


function App() {
  return (
    <div className="app">
      <Header />
      <Routes>

        <Route path="/" element={<Home />}></Route>
        <Route path="sites" element={<Sites />}></Route>
        <Route path="services" element={<Services />}></Route>
        <Route path="team" element={<Team />}></Route>
        <Route path="faq" element={<Faq />}></Route>
      </Routes>

      {/* <Home /> */}
    </div>
  );
}

export default App;
